<script>
import { mapActions, mapGetters } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    components: {
        DatePicker,
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            form: {
                id: '',
                date: '',
                number: '',
                type_id: '',
            },
            original_days:0,
            paid_days: '',
            used_days: '',
            send: false,
        }
    },
    methods: {
        closedModal() {
            this.form.id = '';
            this.form.date = '';
            this.form.number = '';
            this.form.type_id = '';
            this.original_days= 0;
            this.paid_days= '';
            this.used_days= '';
            this.send = false;
            this.errors = {};
            this.$modal.hide('addVacations');
        },
        async saveVacation() {
            this.send = true;
            var max_days=(this.paid_days===''?this.authUser.paid_days:this.paid_days),
                days=(this.used_days===''?this.authUser.approved_days:this.used_days);

            if((this.form.type_id=='P'&&max_days-days-this.form.number+this.original_days>=0)||this.form.type_id=='N'){
                const data_form = new FormData();
                data_form.append('id', this.form.id);
                data_form.append('date[0]', this.form.date[0]);
                data_form.append('date[1]', this.form.date[1]);
                data_form.append('number', this.form.number);
                data_form.append('type', this.form.type_id);

                let _endpoint = '/vacations';
                if (this.form.id != "") {
                    data_form.append('_method', 'PUT');
                    _endpoint = `/vacations/${this.form.id}`;
                }
                try {
                    let { data } = await request.postMedia(_endpoint, data_form)
                    if (data) {
                        // this.users = data.data;
                        this.successNotification(data.message);
                        this.closedModal();
                        Event.$emit('event-load-vacations');
                    }
                } catch (error) {
                    this.send = false;
                    this.errors = {};
                    if (error.response) {

                        this.errors = await this.errorNotification(error);
                    }
                }
            }else{
                this.$swal({
					icon: 'error',
					title: 'Días Superados',
					text: 'Los días pedidos son mayores a los disponibles'
				});
                this.send = false;
            }
        },
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    watch: {
    },
    mounted() {
    },
    created() {
        Event.$on("event-show-addVacation", async (vacation) => {
            if (vacation.id) {
                this.load = true;
                this.form.id = vacation.id;
                this.form.date = [vacation.date_start , vacation.date_end];
                this.form.type_id = vacation.type;
                this.form.number = vacation.number;
                this.paid_days = vacation.paid_days??0;
                this.used_days = vacation.used_days??0;
            }
            this.$modal.show('addVacations');
        });
    },
    computed: {
        ...mapGetters({
            'authUser': 'auth/user'
        })
    },
}
</script>
<template>
    <modal name="addVacations" :width="'80%'" :maxHeight="300" :height="'auto'" v-bind:click-to-close="false">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>
        <form @submit.prevent="saveVacation" method="post" enctype="multipart/form-data">
            <button :disabled="send" type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                    class="fa-solid fa-xmark"></i> </button>
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Agregar Solicitud de Vacaciones</h5>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-6 mt-3">
                        <label>D&iacute;as Disponibles al Año</label>
                        {{ this.paid_days==''?this.authUser.paid_days:this.paid_days }}
                    </div>

                    <div class="col-md-6 mt-3">
                        <label>D&iacute;as Utilizados</label>
                        {{ this.used_days===''?this.authUser.approved_days:this.used_days }}
                    </div>

                    <div class="col-md-6 mt-3">
						<label>Rango de fechas :</label>
                        <date-picker v-model="form.date" :disabled="!prop_edit" :range="true"
                            required="required" valueType="format" format="YYYY-MM-DD" ></date-picker>
                        <div v-if="errors && errors.date" class="text-danger">{{ errors.date[0] }}</div>
                    </div>

                    <div class="col-md-6 mt-3">
                        <label>Tipo de Vacaciones</label>
                        <select type="text" :disabled="!prop_edit" class="form-control"
                            v-model="form.type_id">
                            <option value="P"> Pagadas </option>
                            <option value="N"> No Pagadas </option>
                        </select>
                        <div v-if="errors && errors.type_id" class="text-danger">{{
                            errors.type_payment_id[0] }}
                        </div>
                    </div> 
                    <div class="col-md-6 mt-3">
                        <label>Número de días</label>
                        <input type="number" :disabled="!prop_edit" class="form-control"
                            v-model="form.number">
                        <div v-if="errors && errors.number" class="text-danger">{{ errors.number[0] }}</div>
                    </div>

                    <div class="col-md-12">
                        <hr>
                        <button v-if="prop_edit" :disabled="send" type="submit"
                            class="btn float-right btn-outline-success">
                            <span v-if="send">
                                <i class="fa-solid fa-circle-notch fa-spin"></i> Guardando
                            </span>
                            <span v-else>
                                <i class="fas fa-save"></i> Guardar
                            </span>
                        </button>
                        <button type="button" :disabled="send" @click="closedModal()"
                            class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i>
                            Regresar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.image-upload>input {
    display: none;
}

.del {
    position: absolute;
    right: 0px;
    margin: 10px;
}
</style>